import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ErrorTypeColumn extends Component {
    render() {
        const {errorType} = this.props

        return <td className="Label">
            {errorType}
        </td>
    }
}

ErrorTypeColumn.propTypes = {
    errorType: PropTypes.string
}

export default ErrorTypeColumn